<ix-date
  [ixTest]="[title, rowTestId(row), 'row-date']"
  [date]="date"
></ix-date>
